/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useSelector } from 'react-redux';

import {
    Button,
    ButtonGroup,
    CartActions,
    ModalActions,
    StyledModal,
} from 'sarsaparilla';

import { useTypedDispatch } from '../../../redux';

const { hideCartLimitExceededModal } = CartActions;

interface ReduxState {
    modal: {
        showCartLimitExceededModal: boolean;
    };
}

export default function CartLimitExceededModal() {
    const dispatch = useTypedDispatch();
    const isOpen = useSelector(
        (state: ReduxState) => state.modal.showCartLimitExceededModal
    );

    const handleRequestClose = () => {
        dispatch(hideCartLimitExceededModal());
    };

    return (
        <StyledModal
            heading="Your Cart is Full"
            isOpen={isOpen}
            onRequestClose={handleRequestClose}
        >
            You already have 10 items in your cart, which is the maximum number allowed.
            To add the new item, please remove another one from your cart, or just
            continue to checkout with the original 10 items.
            <ModalActions>
                <ButtonGroup>
                    <Button type="button" onClick={handleRequestClose}>
                        Close
                    </Button>
                </ButtonGroup>
            </ModalActions>
        </StyledModal>
    );
}
